import { render, staticRenderFns } from "./OrdersTable.vue?vue&type=template&id=1fb13bda&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=ts"
export * from "./OrdersTable.vue?vue&type=script&lang=ts"
import style0 from "./OrdersTable.vue?vue&type=style&index=0&id=1fb13bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb13bda",
  null
  
)

export default component.exports